// extracted by mini-css-extract-plugin
export default {"projectListInfo":"AboutProject_projectListInfo__88zmN","projectDescription":"AboutProject_projectDescription__smY7h"};